import { logger } from '@/utils/logging'

const SEO_TITLE_MAX_LENGTH = 60
const SEO_DESCRIPTION_MAX_LENGTH = 160

/**
 * Truncates SEO text to the recommended max length, appending '...' if truncated.
 * Logs a warning when truncation occurs so the copy team can revisit the text.
 */
export function truncateSeoText(
  text: string | null | undefined,
  maxLength: number,
  field: string,
  context?: string,
): string {
  if (!text) return ''
  if (text.length <= maxLength) return text

  logger().debug(`SEO ${field} truncated (${text.length} → ${maxLength} chars)`, {
    field,
    originalLength: text.length,
    maxLength,
    original: text,
    context,
  })

  return text.substring(0, maxLength - 3) + '...'
}

export function truncateSeoTitle(title: string | null | undefined, context?: string): string {
  return truncateSeoText(title, SEO_TITLE_MAX_LENGTH, 'title', context)
}

export function truncateSeoDescription(description: string | null | undefined, context?: string): string {
  return truncateSeoText(description, SEO_DESCRIPTION_MAX_LENGTH, 'description', context)
}
